/* eslint-disable no-console */
import { Flex } from 'components/base/layout-components';
import { DEFAULT_GRAPH_EDIT_CONFIG } from '../../../custom-report.serivce';
import isEmpty from 'lodash/isEmpty';
import EditDefaults from '../EditDefaults/EditDefaults';
import EditSettings from '../EditSettings/EditSettings';

const EditSection = ({
  isHover,
  isEditable,
  editConfig = DEFAULT_GRAPH_EDIT_CONFIG,
  onColorChange,
  graphType,
  onGraphTypeChange,
  onRemove,
  goToSettings,
  selectTeamId,
  globallySelectedTeamId,
  widget,
  isMedian = false
}) => {
  const { id: widgetId, color } = widget;

  if (!isEditable && !isMedian && isEmpty(goToSettings)) {
    return null;
  }

  if (!isHover && !isMedian) {
    return null;
  }

  const editDefaultProps = {
    isEditable,
    isMedian,
    editConfig,
    isHover,
    graphType,
    color,
    onColorChange,
    onGraphTypeChange,
    onRemove
  };

  const editSettingsProps = {
    goToSettings,
    selectTeamId,
    globallySelectedTeamId,
    widgetId
  };

  return (
    <Flex data-testid='graph-box-edit-section' items='center'>
      {!isMedian && <EditDefaults {...editDefaultProps} />}
      <EditSettings {...editSettingsProps} />
      {isMedian && <EditDefaults {...editDefaultProps} />}
    </Flex>
  );
};

export default EditSection;
